import { mugProductTypeIds } from 'src/api/productTypes';
import { Store } from 'src/store';
import { Feature } from 'src/store/app/types';
import getAttributeValue from 'src/store/design/selector/getAttributeValue';
import { DesignData } from 'src/store/design/types';
import getFormatSelectorValue from 'src/store/editor/selector/getFormatSelectorValue';
import { IntegrationLayer } from 'src/types.d';
import isFeatureEnabled from '../feature/isFeatureEnabled';
import adjustMugPrintAndBlankArea from './adjustMugPrintAndBlankArea';
import removeUnsupportedPrintAreas from './removeUnsupportedPrintAreas';

const MUG_PRINT_AREA_ATTRIBUTE_NAME = 'OpMugPrintArea';

const adjustEmptyDesignStructure = (integrationLayer: IntegrationLayer, store: Store, design: DesignData) => {
  let adjustedDesign = design;

  // Adjust mug print areas if needed
  if (isFeatureEnabled(Feature.limitMugPrintArea) && mugProductTypeIds.includes(integrationLayer.productTypeId)) {
    // value from selector has higher priority - use it first
    const mugPrintArea = getFormatSelectorValue(store, MUG_PRINT_AREA_ATTRIBUTE_NAME) || getAttributeValue(store, MUG_PRINT_AREA_ATTRIBUTE_NAME);

    // adjust print area for mugs
    if (mugPrintArea) {
      adjustedDesign = adjustMugPrintAndBlankArea(adjustedDesign, mugPrintArea);
    }
  }

  // Remove unsupported print areas based on available products
  adjustedDesign = removeUnsupportedPrintAreas(adjustedDesign);

  return adjustedDesign;
};

export default adjustEmptyDesignStructure;
